import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { Button } from 'components/buttons'
import { iconsCreator } from 'utils/iconsCreator'
import { ValidationBoundary } from 'components/validation'
import { DialogsSwitch } from 'pages/dialogs'

export const dialogSizes = {
  XS: 'xs', SM: 'sm', MD: 'md', LG: 'lg', XL: 'xl'
}

class DialogBase extends Component {
  onClose = () => { 
    if (this.props.context && typeof this.props.context.onClose === 'function') {
      this.props.context.onClose(this.state)
    }
  }
  modalTitle () { return this.props.localize('common.winelist') }
  modalBody () { return null }
  modalButtons () { return <Button color='primary' onClick={this.close}>{this.props.localize('common.ok')}</Button> }
  modalSize () { return dialogSizes.MD }
  modalIcon () { return null }
  modalClassName () { return this.props.className }
  toggle = () => {
    this.onClose()
    this.props.hideDialog()
  }
  close = () => { this.toggle() }
  render () {
    const { isOpen, localize, hideDialog, nestedDialogs } = this.props
    const title = (<span>{iconsCreator(this.modalIcon())} {this.modalTitle()}</span>)
    return (
      <ValidationBoundary>
        <Modal isOpen={isOpen} toggle={this.toggle} zIndex={1301} className={this.modalClassName()} size={this.modalSize()}>
          <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
          <ModalBody>
            {this.modalBody()}
            <DialogsSwitch dialogs={nestedDialogs} localize={localize} hideDialog={hideDialog} />
          </ModalBody>
          <ModalFooter>
            {this.modalButtons()}
          </ModalFooter>
        </Modal>
      </ValidationBoundary>
    )
  }
}

export {
  DialogBase
}
